export function normalizeWork(source = {}) {
  const id = source.id ?? source.commentId ?? source.workId ?? source.comment_id ?? "";
  const authorName = source.authorName || source.nickname || source.nickName || source.userNickname
    || source.wxNickname || source.creatorName || source.userName || "拼豆玩家";
  const legacyImage = source.displayImage || source.previewImage || source.previewImageBase64 || source.imageUrl
    || source.coverImage || source.picture || source.picUrl || source.url || "";
  const thumbnailImage = source.thumbnailImage || source.thumbnailUrl || source.coverThumbnail
    || source.coverImage || legacyImage;
  const detailImage = source.displayImage || source.detailImage || source.detailImageUrl || source.originalImage
    || source.originalImageUrl || source.fullImage || source.imageUrl || legacyImage;
  const originalImage = source.originalImage || source.originalImageUrl || source.sourceImage
    || source.sourceImageUrl || "";
  const hasDisplayImage = Boolean(source.displayImage || source.detailImage || source.detailImageUrl);
  const favoriteCount = numberValue(source.favoriteCount, source.collectNum, source.collectCount, source.likeNum);
  const heatScore = numberValue(source.heatScore, source.hotScore, source.heat);
  const gridWidth = numberValue(source.gridWidth, source.width, source.xCount);
  const gridHeight = numberValue(source.gridHeight, source.height, source.yCount);
  const totalCount = numberValue(source.totalCount, source.beadCount, source.count);
  const colorCount = numberValue(source.colorCount, source.colors, source.paletteCount);
  return {
    ...source,
    id,
    commentId: source.commentId ?? id,
    title: source.title || source.name || source.commentName || "未命名作品",
    description: source.description || source.content || source.introduction || "记录一份拼豆灵感与创作过程。",
    tagId: source.tagId || source.topicId || "",
    tagName: source.tagName || source.topicName || "",
    authorName,
    authorAvatar: source.authorAvatar || source.avatar || source.avatarUrl || source.headImg || "",
    // 列表优先显示缩略图；详情页通过 detailImage 保留原图。
    previewImage: thumbnailImage || legacyImage,
    thumbnailImage,
    displayImage: detailImage,
    detailImage,
    // 原图与卡通展示图必须独立；历史数据缺原图时应明确提示，不能拿卡通图冒充。
    originalImage,
    hasOriginalImage: Boolean(originalImage),
    hasDisplayImage,
    favoriteCount,
    heatScore,
    gridWidth,
    gridHeight,
    totalCount,
    colorCount,
    paletteKey: source.paletteKey || source.palette || source.brand || "通用色卡",
    paletteLabel: source.paletteLabel || source.paletteName || source.paletteKey || source.palette || "通用色卡",
    collect: Boolean(source.collect ?? source.favorited ?? source.collected),
    createdAt: source.createdAt || source.createTime || source.createdTime || source.date || "",
    openId: source.openId || source.userOpenId || source.creatorOpenId || "",
    userId: source.userId || source.creatorId || source.createBy || "",
    memberAuthor: Boolean(source.memberAuthor || source.authorMember || source.vip)
  };
}

export function normalizeWorkPage(response) {
  if (Array.isArray(response)) return { list: response.map(normalizeWork), total: response.length };
  const list = response?.list || response?.records || response?.items || response?.rows || response?.content || [];
  const total = numberValue(response?.total, response?.totalCount, response?.count, response?.pagination?.total, list.length);
  return { list: Array.isArray(list) ? list.map(normalizeWork) : [], total };
}

export function formatWorkDate(value) {
  if (!value) return "最近发布";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat("zh-CN", { month: "short", day: "numeric" }).format(date);
}

export function authorInitial(name) {
  return String(name || "拼").trim().slice(0, 1).toUpperCase();
}

function numberValue(...values) {
  const found = values.find((value) => value !== undefined && value !== null && value !== "" && Number.isFinite(Number(value)));
  return found === undefined ? 0 : Number(found);
}
